<div class="mb-5">
  @if (isLoadingImage) {
  <div
    class="max-h-[210px] aspect-id-card mx-auto rounded-xl overflow-hidden border border-dashed border-shade-two bg-white flex flex-col items-center justify-center gap-3 text-shade-three">
    <ion-spinner color="dark"></ion-spinner>
    <p class="m-0 text-sm font-medium">Uploading image...</p>
  </div>
  }

  @if (!image && !isLoadingImage) {
  <div
    class="max-h-[210px] aspect-id-card mx-auto rounded-xl overflow-hidden border border-dashed bg-white relative flex flex-col items-center justify-center"
    [class.border-shade-two]="!error?.length" [class.border-ion-danger]="error?.length > 0">
    <h1 class="text-base m-0 mt-1 text-gray-800">Upload {{ title }}</h1>
    <div class="flex items-center justify-center">
      <button class="flex flex-col items-center justify-center bg-transparent text-base p-2.5 rounded-sm m-2.5 w-24"
        (click)="openCamera()">
        <ion-icon name="camera-outline" class="p-2.5 text-3xl"></ion-icon>
        Camera
      </button>
      <div class="w-px h-14 bg-shade-one"></div>
      <button class="flex flex-col items-center justify-center bg-transparent text-base p-2.5 rounded-sm m-2.5 w-24"
        (click)="openLibrary()">
        <ion-icon name="image-outline" class="p-2.5 text-3xl"></ion-icon>
        Library
      </button>
    </div>
  </div>
  }

  @if (image && !isLoadingImage) {
  <div
    class="max-h-[210px] aspect-id-card mx-auto rounded-xl overflow-hidden shadow-card bg-cover bg-no-repeat bg-center relative"
    [class.cursor-pointer]="!isProcessing" [class.cursor-default]="isProcessing"
    [class.pointer-events-none]="isProcessing" [style.backgroundImage]="'url(' + image + ')'"
    (click)="openImagePreview()">
    @if (isProcessing) {
    <div
      class="absolute inset-0 flex flex-col items-center justify-center gap-3 z-20 bg-black/40 text-white pointer-events-none">
      <ion-spinner color="light"></ion-spinner>
      <p class="m-0 text-sm font-medium">Verifying</p>
    </div>
    }
    <div
      class="w-full h-full absolute inset-0 bg-gradient-to-b from-black/20 to-transparent text-white flex flex-col items-start justify-between pointer-events-none">
      <p class="m-5 font-bold drop-shadow-md">{{ title }}</p>
    </div>
    <button
      class="absolute right-0 top-1/2 -translate-y-1/2 rounded-l-xl bg-ion-danger text-white text-xl p-2.5 m-0 flex items-center justify-center transition-all duration-100 cursor-pointer z-10 hover:pr-5 pointer-events-auto"
      (click)="removeImage($event)">
      <ion-icon name="trash-outline"></ion-icon>
    </button>
  </div>
  }

  <custom-image-cropper [imageUrl]="originalImage" [isOpen]="showCropper" [title]="title"
    (croppedImageUrl)="onCroppedImage($event)" (cancel)="onCropCancel()">
  </custom-image-cropper>

  @if (error) {
  <p class="mt-1.5 mx-6 text-ion-danger font-bold">{{ error }}</p>
  }

  <app-upload-image-button #uploadImageButtonComponent hidden (onImageUpload)="onImageLoad($event)">
  </app-upload-image-button>
</div>